import React, { useEffect, useRef, useState } from 'react';

const ReCaptcha = ({ siteKey, callback, setVerified }) => {
    const recaptchaRef = useRef(null);
    const [isRecaptchaLoaded, setIsRecaptchaLoaded] = useState(false);

    // Define the component function to be called when reCAPTCHA loads
    const onRecaptchaLoad = () => {
        setIsRecaptchaLoaded(true);
    };

    useEffect(() => {
        // Assign the component function to the window callback
        (window as any).onRecaptchaLoad = onRecaptchaLoad;

        if (!(window as any).grecaptcha) {
            // Load the script only if it's not already available
            const script = document.createElement('script');
            script.src = "https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit";
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        } else if ((window as any).grecaptcha && (window as any).grecaptcha.render) {
            // If reCAPTCHA is already loaded, call the function directly
            onRecaptchaLoad();
        }

        // Clean up the global callback on component unmount
        return () => {
            (window as any).onRecaptchaLoad = null;
        };
    }, []);

    useEffect(() => {
        if (isRecaptchaLoaded) {
            (window as any).grecaptcha.render(recaptchaRef.current, {
                'sitekey': siteKey,
                'callback': callback, // Callback function to handle the token
                'expired-callback': () => {
                    setVerified(false)
                },
                'theme': 'light'
            });
        }
    }, [isRecaptchaLoaded]);

    return (
        <div ref={recaptchaRef}></div>
    );
};

export default ReCaptcha;